export const removeExtendedSpacing =(p)=>p.replaceAll(/\s+/g, " ").trim();
 